module.exports = __webpack_public_path__ + "OurVisiofor5G_2_esp.jpg?43ca6d6c9003c2fe21609d9ec2287867";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/OurVisiofor5G_2_esp.jpg
// module id = 192
// module chunks = 0